import { atom } from "recoil";

const listCheckPaymentAtom = atom({
  key: "listCheckPayment",
  default: [],
});
const listReminingPaymentAtom = atom({
  key: "listReminingPayment",
  default: [],
});

export { listCheckPaymentAtom, listReminingPaymentAtom };


